import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import "./Team.css";

import ceoImg from "../assets/ceo.webp";
import tusharImg from "../assets/tushar_anpat.webp";
import AniImg from "../assets/aniket.webp";
import CDImg from "../assets/siddhi.webp";

import AOS from "aos";
import "aos/dist/aos.css";

const teamMembers = [
  {
    name: "Vaibhav Anpat",
    designation: "Founder & CEO",
    description:
      "Owner & Founder of Wellness Electromedical Systems Pvt Ltd. (WEMS) with 10+ years of experience in the Electromedical field.",
    image: ceoImg,
    isCEO: true,
  },
  {
    name: "Tushar Anpat",
    designation: "Design & Development Manager",
    description: "Leads web and software development for hospital systems.",
    image: tusharImg,
  },
  {
    name: "Aniket Anpat",
    designation: "IT Team",
    description: "Focuses on frontend performance and user experience.",
    image: AniImg,
  },
  {
    name: "Siddhi Gandhi",
    designation: "IT Team",
    description: "Handles backend systems and APIs.",
    image: CDImg,
  },
];

function Team() {
  useEffect(() => {
    AOS.init({ duration: 900, easing: "ease-out-cubic", once: true });
  }, []);

  return (
    <>
      {/* ================= SEO ================= */}
      <Helmet>
        <title>
          Vaibhav Anpat | Founder & CEO of WEMS Modular OT India
        </title>

        <meta
          name="description"
          content="Vaibhav Anpat is the Founder & CEO of WEMS (Wellness Electromedical Systems), specializing in Modular Operation Theatre, hospital OT design, laminar airflow systems, and cleanroom solutions across India."
        />

        <meta
          name="keywords"
          content="Vaibhav Anpat, WEMS CEO, Modular OT India founder, Operation Theatre Pune, hospital OT design India, laminar airflow OT systems"
        />

        <link
          rel="canonical"
          href="https://www.wellnessmodularot.com/team"
        />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="Vaibhav Anpat | Founder & CEO - WEMS"
        />
        <meta
          property="og:description"
          content="Founder of WEMS Modular OT solutions, leading hospital infrastructure and OT design projects across India."
        />
        <meta
          property="og:image"
          content="https://www.wellnessmodularot.com/assets/ceo.webp"
        />
        <meta property="og:type" content="profile" />

        {/* JSON-LD Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Person",
            name: "Vaibhav Anpat",
            jobTitle: "Founder & CEO",
            worksFor: {
              "@type": "Organization",
              name: "Wellness Electromedical Systems Pvt Ltd. (WEMS)",
            },
            description:
              "Founder & CEO of WEMS specializing in Modular Operation Theatre, hospital infrastructure, and cleanroom systems.",
            image:
              "https://www.wellnessmodularot.com/assets/ceo.jpg",
            url: "https://www.wellnessmodularot.com/team",
          })}
        </script>
      </Helmet>

      {/* ================= UI ================= */}
      <section className="team-page" id="team">
        <div className="team-header" data-aos="fade-up">
          <span className="team-tag">The People Behind WEMS</span>
          <h2>
            Our <span>Team</span>
          </h2>
        </div>

        <div className="team-container">
          {teamMembers.map((member, index) =>
            member.isCEO ? (
              <a href="/vaibhav-anpat" className="team-card-link" key={index}>
                <div
                  className="team-card ceo-card"
                  data-aos="fade-up"
                  data-aos-delay={index * 100}
                  itemScope
                  itemType="https://schema.org/Person"
                >
                  <div className="team-image">
                    <div className="img-ring" />
                    <img
                      src={member.image}
                      alt="Vaibhav Anpat - Founder & CEO of Wellness Electromedical Systems Pvt Ltd. (WEMS) Modular OT India"
                      itemProp="image"
                    />
                  </div>

                  <h3 itemProp="name">{member.name}</h3>

                  <p className="designation" itemProp="jobTitle">
                    {member.designation}
                  </p>

                  <p className="description">{member.description}</p>

                  <span className="know-more-btn">Know More →</span>
                </div>
              </a>
            ) : (
              <div
                className="team-card"
                key={index}
                data-aos="fade-up"
                data-aos-delay={index * 100}
              >
                <div className="team-image">
                  <div className="img-ring" />
                  <img src={member.image} alt={member.name} />
                </div>

                <h3>{member.name}</h3>
                <p className="designation">{member.designation}</p>
                <p className="description">{member.description}</p>
              </div>
            )
          )}
        </div>
      </section>
    </>
  );
}

export default Team;